import React from 'react';
import bibimcosanDetail from '../img/Detail/bibimcosan-detail.jpg';
import './Detail.css';
const BibimcosanDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={bibimcosanDetail} alt="Bibimcosan" />
    </div>
  );
};

export default BibimcosanDetail;
